import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import Features from "@/components/Features";
import AboutContact from "@/components/AboutContact";
import Footer from "@/components/Footer";

const Home = () => {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => {
        if (lenis) lenis.scrollTo(`#${target}`, { offset: -80, duration: 1.1 });
        else {
          const el = document.getElementById(target);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis]);

  return (
    <div className="bg-paper" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Features />
        <AboutContact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
